import { DEFAULT_DASHBOARD_LAYOUT } from '@hearth/shared';
import { createFileRoute } from '@tanstack/react-router';
import { Builder } from '@/components/customisation/builder/builder';
import { useSiteDraft } from '@/lib/customisation/site-draft';

export const Route = createFileRoute('/_app/admin/customisation/dashboard')({ component: Page });

/**
 * The customer dashboard builder. The layout is `site.dashboard` in the shared site draft,
 * so undo/redo, autosave and publishing are the studio's; this page only edits the tree.
 */
function Page() {
  const draft = useSiteDraft();
  return (
    <div className="flex min-h-[60dvh] flex-col lg:h-[calc(100dvh-9.25rem)]">
      <Builder
        tenant={draft.tenant}
        surface="dashboard"
        layout={draft.site.dashboard}
        onChange={(next, label) =>
          draft.update((s) => {
            s.dashboard = next;
          }, label)
        }
        undo={draft.undo}
        redo={draft.redo}
        canUndo={draft.canUndo}
        canRedo={draft.canRedo}
        onReset={() =>
          draft.update((s) => {
            s.dashboard = JSON.parse(JSON.stringify(DEFAULT_DASHBOARD_LAYOUT));
          }, 'Reset to default layout')
        }
      />
    </div>
  );
}
